module.exports = __webpack_public_path__ + "img/andrew_cutout.51070cfe.png";